export const tokenAddresses = [
  {
    tokenName: "Dai token",
    tokenSymbol: "DAI",
    tokenAddress: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
    //tokenAddress: "0x9e545e3c0baab3e08cdfd552c960a1050f373042",
    tokenDecimals: "18",
  },
  {
    tokenName: "Tether USD",
    tokenSymbol: "USDT",
    tokenAddress: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
    tokenDecimals: "6"
  },
  // {
  //   tokenName: "Rocket Pool ETH",
  //   tokenSymbol: "rETH",
  //   tokenAddress: "0xae78736Cd615f374D3085123A210448E74Fc6393",
  //   tokenDecimals: "18"
  // },
  {
    tokenName: "USDC token",
    tokenSymbol: "USDC",
    tokenAddress: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
    tokenDecimals: "6"
  },
  // {
  //   tokenName: "Wrapped liquid staked Ether 2.0",
  //   tokenSymbol: "wstETH",
  //   tokenAddress: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
  //   tokenDecimals: "18"
  // },
  // {
  //   tokenName: "USDS",
  //   tokenSymbol: "USDS",
  //   tokenAddress: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
  //   tokenDecimals: "18"
  // },
  // {
  //   tokenName: "Uniswap",
  //   tokenSymbol: "Uni",
  //   tokenAddress: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
  //   tokenDecimals: "18"
  // },
  // {
  //   tokenName: "Wrapped BTC",
  //   tokenSymbol: "WBTC",
  //   tokenAddress: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
  //   tokenDecimals: "8"
  // },
  {
    tokenName: "Wrapped Ether",
    tokenSymbol: "WETH",
    tokenAddress: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
    // tokenAddress: "0x84ea74d481ee0a5332c457a4d796187f6ba67feb",
    tokenDecimals: "18"
  },
  // {
  //   tokenName: "Lido DAO Token",
  //   tokenSymbol: "LDO",
  //   tokenAddress: "0x5A98FcBEA516Cf06857215779Fd812CA3beF1B32",
  //   tokenDecimals: "18"
  // },
  // {
  //   tokenName: "ChainLink Token",
  //   tokenSymbol: "LINK",
  //   tokenAddress: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
  //   tokenDecimals: "18"
  // },
  {
    tokenName: "Maker",
    tokenSymbol: "MKR",
    tokenAddress: "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2",
    tokenDecimals: "18"
  },
  {
    tokenName: "Compound",
    tokenSymbol: "COMP",
    tokenAddress: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
    tokenDecimals: "18"
  },  
  // {
  //   tokenName: "Arbitrum",
  //   tokenSymbol: "ARB",
  //   tokenAddress: "0xB50721BCf8d664c30412Cfbc6cf7a15145234ad1",
  //   tokenDecimals: "18"
  // },
  // {
  //   tokenName: "Wrapped eETH",
  //   tokenSymbol: "weeth",
  //   tokenAddress: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
  //   tokenDecimals: "18"
  // },
  // {
  //   tokenName: "USDe",
  //   tokenSymbol: "USDe",
  //   tokenAddress: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
  //   tokenDecimals: "18"
  // },
  // {
  //   tokenName: "Coinbase Wrapped BTC",
  //   tokenSymbol: "cbBTC",
  //   tokenAddress: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
  //   tokenDecimals: "8"
  // }
]